import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';

const columnsAmountOptions = {
  ONE_COLUMN: '1-columns',
  TWO_COLUMNS: '2-columns',
  THREE_COLUMNS: '3-columns',
  FOUR_COLUMNS: '4-columns',
  FIVE_COLUMNS: '5-columns',
  SIX_COLUMNS: '6-columns',
};

const columnsAmountValueByOption = {
  [columnsAmountOptions.ONE_COLUMN]: '12/12',
  [columnsAmountOptions.TWO_COLUMNS]: '6/12',
  [columnsAmountOptions.THREE_COLUMNS]: '4/12',
  [columnsAmountOptions.FOUR_COLUMNS]: '3/12',
  [columnsAmountOptions.SIX_COLUMNS]: '2/12',
};

const columnsAmountValuesByOption = {
  [columnsAmountOptions.ONE_COLUMN]: {
    [breakpointKeys.DEFAULT]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
    [breakpointKeys.MAX_XL]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
    [breakpointKeys.MAX_MD]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
  },
  [columnsAmountOptions.TWO_COLUMNS]: {
    [breakpointKeys.DEFAULT]: columnsAmountValueByOption[columnsAmountOptions.TWO_COLUMNS],
    [breakpointKeys.MAX_XL]: columnsAmountValueByOption[columnsAmountOptions.TWO_COLUMNS],
    [breakpointKeys.MAX_MD]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
  },
  [columnsAmountOptions.THREE_COLUMNS]: {
    [breakpointKeys.DEFAULT]: columnsAmountValueByOption[columnsAmountOptions.THREE_COLUMNS],
    [breakpointKeys.MAX_XL]: columnsAmountValueByOption[columnsAmountOptions.TWO_COLUMNS],
    [breakpointKeys.MAX_MD]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
  },
  [columnsAmountOptions.FOUR_COLUMNS]: {
    [breakpointKeys.DEFAULT]: columnsAmountValueByOption[columnsAmountOptions.FOUR_COLUMNS],
    [breakpointKeys.MAX_XL]: columnsAmountValueByOption[columnsAmountOptions.TWO_COLUMNS],
    [breakpointKeys.MAX_MD]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
  },
  [columnsAmountOptions.SIX_COLUMNS]: {
    [breakpointKeys.DEFAULT]: columnsAmountValueByOption[columnsAmountOptions.SIX_COLUMNS],
    [breakpointKeys.MAX_XL]: columnsAmountValueByOption[columnsAmountOptions.TWO_COLUMNS],
    [breakpointKeys.MAX_MD]: columnsAmountValueByOption[columnsAmountOptions.ONE_COLUMN],
  },
};

export default columnsAmountOptions;
export { columnsAmountValueByOption, columnsAmountValuesByOption };
